<div *transloco="let t" class="flex flex-col gap-8">
    <form [formGroup]="groupForm" class="grid gap-2 w-full mt-10">
        <mat-form-field appearance="fill" class="full-width" placeholder="Select Solution" floatLabel="always">
            <mat-label>{{t('Solution')}}</mat-label>
            <mat-select formControlName="solution" placeholder="Select Solution" required>
                <mat-select-trigger>
                    {{ getSolutionName(groupForm.value.solution) }}
                </mat-select-trigger>
                <mat-option *ngFor="let option of solutions" [value]="option.key">
                    <mat-icon [svgIcon]="option.icon || ''"></mat-icon>
                    <div>{{ option.title }}</div>
                    <div class="text-xs opacity-30 -mt-2">
                        {{option.description}}
                    </div>
                </mat-option>
            </mat-select>
        </mat-form-field>

        <mat-form-field appearance="fill" class="full-width">
            <mat-label>{{t('Group Name')}}</mat-label>
            <input matInput formControlName="notes" class="ring-0"/>
            <mat-error *ngIf="groupForm.get('notes')?.hasError('required')">
                {{t('Group Name is required')}}
            </mat-error>
        </mat-form-field>

        <div class="flex gap-2 w-full items-center full-width">
            <mat-form-field appearance="fill" class="full-width w-full">
                <mat-label>{{t('Group Alias')}}</mat-label>
                <input matInput formControlName="alias" class="ring-0">
                <mat-hint align="start" class="text-sm text-slate-400 ring-0">{{t('Group Alias must be unique')}}</mat-hint>
                <mat-error *ngIf="groupForm.get('alias')?.hasError('required')">
                    {{t('Group Alias is required')}}
                </mat-error>
            </mat-form-field>
            <app-select-icon [defaultIcon]="groupForm.value.description" (selected)="selectIcon($event)"></app-select-icon>
        </div>

    </form>

    <div class="w-full flex justify-end gap-4">
        <button class="min-w-32 px-4 py-2 rounded-full text-white bg-rose-500" (click)="cancelClick()">
            {{t('Cancel')}}
        </button>

        <button 
            type="submit" 
            class="min-w-32 px-4 py-2 rounded-full text-white bg-primary-base" 
            [disabled]="groupForm.invalid" 
            [class]="groupForm.invalid ? 'bg-slate-400' : 'bg-primary'"
            (click)="type === 'create' ? createGroupSubmit() : updateGroupSubmit()"
        >
            {{ type === 'create' ? t('Create') : t('Update') }}
        </button>
    </div>
</div>